import React from 'react';
import './BrandLogo.css';

export interface BrandLogoProps {
  className?: string;
  /** Show the "Türkiye'nin Bilgisayar Pazarı" tagline under the domain (hidden on xs). */
  showTagline?: boolean;
  imgHeight?: number;
}

const BrandLogo: React.FC<BrandLogoProps> = ({
  className = '',
  showTagline = true,
  imgHeight = 40,
}) => (
  <span className={`sb-brand d-inline-flex align-items-center ${className}`.trim()}>
    <img
      src="/logo-mark.svg"
      alt="SadeceBilgisayar"
      className="sb-brand__mark flex-shrink-0"
      width={imgHeight}
      height={imgHeight}
    />
    <span className="sb-brand__text d-flex flex-column">
      <span className="sb-brand__name">sadecebilgisayar.com</span>
      {showTagline && (
        <span className="sb-brand__tagline d-none d-sm-block">Türkiye'nin Bilgisayar Pazarı</span>
      )}
    </span>
  </span>
);

export default BrandLogo;
